module.exports = __webpack_public_path__ + "static/body_2-02f70af74ce9ae30a99cd08c078bb1b7.png";